import { render } from "./CourseComparison.vue?vue&type=template&id=7ba64cd6&scoped=true"
import script from "./CourseComparison.vue?vue&type=script&lang=js"
export * from "./CourseComparison.vue?vue&type=script&lang=js"

import "./CourseComparison.vue?vue&type=style&index=0&id=7ba64cd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba64cd6"]])

export default __exports__